import PocketBase from 'pocketbase';

import { POCKETBASE_URL } from '../config';

const pb = new PocketBase(POCKETBASE_URL);

// Fetch all pilotos de peso records
export async function fetchPilotosPeso() {
    try {
        const records = await pb.collection('egresoCab_Piloto_Peso').getFullList({
            sort: '-fecha',
            fields: 'fecha,nombre,numero,total_peso,total,escoltas_count,escoltas_nombres,target_ref,transporte_descrip,transporte_ref,delivery_method'
        });
        return records.map(record => ({
            fecha: record.fecha,
            nombre: record.nombre,
            numero: record.numero,
            total_peso: record.total_peso,
            total: record.total,
            escoltas_count: record.escoltas_count,
            escoltas_nombres: record.escoltas_nombres,
            target_ref: record.target_ref,
            transporte_descrip: record.transporte_descrip,
            transporte_ref: record.transporte_ref,
            delivery_method: record.delivery_method
        }));
    } catch (error) {
        console.error('Error fetching pilotos de peso report:', error);
        throw error;
    }
}

// Save a piloto de peso
export async function savePilotoPeso(pilotoPeso) {
    try {
        if (pilotoPeso.id) {
            // Update existing record
            return await pb.collection('pilotoPeso').update(pilotoPeso.id, pilotoPeso);
        } else {
            // Create new record
            return await pb.collection('pilotoPeso').create(pilotoPeso);
        }
    } catch (error) {
        console.error('Error saving piloto de peso:', error);
        throw error;
    }
}

// Remove a piloto de peso
export async function removePilotoPeso(id) {
    try {
        return await pb.collection('pilotoPeso').delete(id);
    } catch (error) {
        console.error('Error removing piloto de peso:', error);
        throw error;
    }
}

// Search pilotos de peso records
export async function searchPilotosPeso(query) {
    try {
        const records = await pb.collection('egresoCab_Piloto_Peso').getFullList({
            filter: `nombre ~ "${query}"`,
            sort: '-fecha',
            fields: 'fecha,nombre,numero,total_peso,total,escoltas_count,escoltas_nombres,target_ref,transporte_descrip,transporte_ref,delivery_method'
        });
        return records.map(record => ({
            fecha: record.fecha,
            nombre: record.nombre,
            numero: record.numero,
            total_peso: record.total_peso,
            total: record.total,
            escoltas_count: record.escoltas_count,
            escoltas_nombres: record.escoltas_nombres,
            target_ref: record.target_ref,
            transporte_descrip: record.transporte_descrip,
            transporte_ref: record.transporte_ref,
            delivery_method: record.delivery_method
        }));
    } catch (error) {
        console.error('Error searching pilotos de peso report:', error);
        throw error;
    }
}

// Subscribe to changes
export function subscribeToPilotosPeso(callback) {
    return pb.collection('egresoCab_Piloto_Peso').subscribe('*', callback);
}

// Unsubscribe from changes
export function unsubscribeFromPilotosPeso(subscription) {
    if (subscription) {
        subscription.unsubscribe();
    }
} 